import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CustomIcons } from '@shared/models/custom-icons';
import { tap } from 'rxjs/operators';
import { ConnectedPosition } from "@angular/cdk/overlay";

@Component({
  selector: 'app-registry-export',
  templateUrl: './registry-export.component.html',
  styleUrls: ['./registry-export.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistryExportComponent {
  private _isMobile = false;
  public cdkPosition: ConnectedPosition[] = [
    {
      originX: 'end',
      overlayX: 'end',
      originY: 'top',
      overlayY: 'top',
      offsetY: 35
    }
  ];
  public breakpointObserve$ = this.breakpointObserver.observe(['(max-width: 1800px)', '(max-width: 420px)']).pipe(
    tap(state => {
      this._isMobile = state.breakpoints['(max-width: 420px)'];
    })
  );
  public icons = CustomIcons;
  public isOpenExport = false;
  constructor(private breakpointObserver: BreakpointObserver) {}

  /*  public openModal(): void {
    const config = this._isMobile
      ? {
          maxWidth: '100%',
          width: '100%',
          position: {
            bottom: '0px'
          },
          panelClass: 'mobile-bottom-show-up-small-dialog',
          backdropClass: 'backdrop',
          hasBackdrop: true
        }
      : { backdropClass: 'closer-backdrop' };
    this.dialog.open(RegistryExportModalComponent, config);
  } */
}
